import React, { FC } from 'react';

import {
	MobileErrorMessage,
	MobileErrorType
} from 'src/apps/mobile-common/components/mobile-error-message/MobileErrorMessage';
import { ProductType } from 'src/common/interfaces/Tenant';

interface MfaErrorProps {
	errorType?: MobileErrorType;
}

export const MfaError: FC<MfaErrorProps> = ({ errorType = MobileErrorType.LOADING_ERROR }) => {
	return (
		<MobileErrorMessage errorType={errorType} productType={ProductType.MOBILE_FLOW_ANALYZER} />
	);
};
